import React, {useEffect} from 'react';

import {
    sendDesktopAnalyticsEvent,
    sendDesktopAnalyticsPerSession,
} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {RoundButton} from '@optimaxdev/design-system';
import {useInView} from 'react-intersection-observer';

import {Price} from 'components/price/price';
import {TYP_MENTION_ME} from 'constants/analytics/events/typ';
import {ORDER_TRACKING} from 'constants/analytics/mentionMe';

import {useMentionMe} from '../hooks/useMentionMe';
import {PropsMentionType} from '../mentionMeTypes';

import s from './mentionMeBannerV2.scss';

/**
 * Mention me banner at the bottom of rewards banner
 */
export const MentionMeBannerV2 = ({classes = '', integratingType, params}: PropsMentionType) => {
    const {generateScript, shouldHide} = useMentionMe(params, integratingType);
    const {generateScript: generateOrderScript} = useMentionMe(params, ORDER_TRACKING);

    const {inView, ref} = useInView();

    const onCtaClick = () => {
        sendDesktopAnalyticsEvent(TYP_MENTION_ME, {
            label: 'CTA - Clicked',
        });
        generateScript();
    };

    useEffect(() => {
        if (!shouldHide && inView)
            sendDesktopAnalyticsPerSession({
                event: TYP_MENTION_ME,
                isInteraction: true,
                label: 'CTA - Showed',
            });
    }, [shouldHide, inView]);

    useEffect(() => {
        generateOrderScript();
    }, [generateOrderScript]);

    if (shouldHide) return null;

    return (
        <article className={s.wrapper} ref={ref}>
            <h3 className={s.title}>
                <span aria-label="sparks" role="img">
                    ✨
                </span>{' '}
                Give <Price>25</Price>, Get <Price>25</Price>!{' '}
                <span aria-label="sparks" role="img">
                    ✨
                </span>
            </h3>
            <p className={s.paragraph}>
                Invite your loved ones to shop, and you’ll both enjoy{' '}
                <b>
                    EXTRA <Price>25</Price> OFF
                </b>
                {'  '}— their first order and your next one.
            </p>
            <RoundButton className={s.cta} isFull={false} onClick={onCtaClick}>
                Share & Enjoy <Price>25</Price>!
            </RoundButton>
            <div className={classes} data-testid="mmWrapper" id="mmWrapper" role="presentation" />
        </article>
    );
};
